/**
 * Collection listing quick-add — Workshop Manual Hub.
 *
 * Intercepts product forms in .wmh-rows, POSTs /cart/add.js, stays on the
 * listing, and flashes the submit label to "Added". Native form POST remains
 * the no-JS fallback (Shopify cart page). Header count is best-effort.
 */
(function () {
  var ADDED_MS = 2000;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addUrl(container) {
    return (container && container.getAttribute('data-wmh-cart-add')) || cartRoot() + 'cart/add.js';
  }

  function cartJsUrl(container) {
    return (container && container.getAttribute('data-wmh-cart-js')) || cartRoot() + 'cart.js';
  }

  function labelEl(btn) {
    return btn.querySelector('[data-wmh-add-label]') || btn;
  }

  function setBusy(btn, busy) {
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function statusEl(form) {
    return form.querySelector('[data-wmh-add-status]');
  }

  function showError(form, msg) {
    var live = statusEl(form);
    if (live) live.textContent = msg;
  }

  function clearError(form) {
    var live = statusEl(form);
    if (live) live.textContent = '';
  }

  function variantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input && input.value;
  }

  function refreshHeaderCount(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));

    var nodes = document.querySelectorAll(
      '[data-cart-count], [data-cart-item-count], cart-icon .count, .cart-count, .cart-bubble'
    );
    var text = String(count);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = text;
    }

    var icons = document.querySelectorAll('cart-icon');
    for (var j = 0; j < icons.length; j++) {
      icons[j].setAttribute('data-count', text);
      if (typeof icons[j].refresh === 'function') icons[j].refresh();
    }
  }

  function onSuccess(btn, form) {
    clearError(form);
    var label = labelEl(btn);
    var original = label.getAttribute('data-original') || label.textContent.trim();
    label.setAttribute('data-original', original);
    label.textContent = 'Added';
    setBusy(btn, true);
    window.setTimeout(function () {
      label.textContent = original;
      setBusy(btn, false);
    }, ADDED_MS);
  }

  function parseJson(res) {
    return res
      .json()
      .catch(function () {
        throw new Error('Could not add to cart');
      })
      .then(function (data) {
        if (!res.ok) {
          var message = (data && (data.description || data.message)) || 'Could not add to cart';
          throw new Error(message);
        }
        return data;
      });
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('.wmh-rows')) return;
    if (!form.querySelector('input[name="id"]')) return;

    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled) {
      e.preventDefault();
      return;
    }

    var id = variantId(form);
    if (!id) return;

    e.preventDefault();
    clearError(form);
    setBusy(btn, true);

    var rows = form.closest('.wmh-rows');
    fetch(addUrl(rows), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: Number(id), quantity: 1 }),
    })
      .then(parseJson)
      .then(function () {
        onSuccess(btn, form);
        return fetch(cartJsUrl(rows), { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) return null;
            return res.json();
          })
          .catch(function () {
            return null;
          });
      })
      .then(function (cart) {
        if (cart) refreshHeaderCount(cart);
      })
      .catch(function (err) {
        setBusy(btn, false);
        showError(form, (err && err.message) || 'Could not add to cart');
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
